module.exports = __webpack_public_path__ + "img/logo3.d6fabdc2.png";